import rater from 'rater-js';

class Rating
{
    /**
     * @param element
     * @param {function(this)|null} callback
     */
    constructor(element, callback = null) {
        this.container = element;
        this.rateCallback = callback;
        this.sourceValue = Number(this.container.getAttribute('data-value'));

        this.ratingValueElement = this.container.querySelector('[data-rating="value"]');
        this.starsElement = this.container.querySelector('[data-rating="stars"]');

        this.rater = rater({
            max: 5,
            step: 1,
            starSize: 20,
            rating: this.sourceValue,
            element: this.starsElement,
            rateCallback: (rating, done) => {
                this.rate(rating);
                done();
            },
        });

        if (this.starsElement.getAttribute('data-disabled')) {
            this.rater.disable();
        }
    }

    /**
     * @param {Number} rating
     */
    rate(rating) {
        if (this.ratingValueElement) {
            this.ratingValueElement.textContent = String(rating);
        }

        this.rater.setRating(rating);
        this.rater.disable();

        if (this.rateCallback) {
            this.rateCallback(this);
        }
    }

    enable() {
        this.rater.enable();
    }

    /**
     * @return {Number}
     */
    value() {
        return this.rater.getRating();
    }

    reset() {
        if (this.ratingValueElement) {
            this.ratingValueElement.textContent = String(this.sourceValue);
        }

        this.rater.setRating(this.sourceValue);
        this.rater.enable();
    }
}

export {Rating};
